import {helpers, maxLength, required} from '@vuelidate/validators';
import {ref} from 'vue';
import type {FormElementItem} from '~/lib/types/formTypes';
import {getRiskLevelText} from '~/lib/riskHelper';
import type {Risk, RiskDeviation} from '~/lib/types/riskTypes';
import FineAndKinneyToolComponent from '~/components/risks/FineAndKinneyToolComponent.vue';

export const levelDeviationLabels = {
	level: 'Afwijkende risicoklasse',
	reason: 'Motivatie van afwijking risicoklasse'
} satisfies Partial<Record<keyof RiskDeviation, string>>;

export default (originalLevel: Risk['level'], initialValue?: Risk['levelDeviation']) => {

	const emptyForm: Risk['levelDeviation'] = {
		level: originalLevel,
		reason: ''
	};

	const formFields = ref<RiskDeviation>({
		...emptyForm,
		...initialValue
	});

	const originalLevelChanged = (value: string) => {
		if (value === originalLevel) {
			return false;
		}
		return true;
	};

	const formSchema: Array<FormElementItem> = [
		{
			key: 'level',
			type: 'radio',
			label: levelDeviationLabels.level,
			validators: {
				required,
				requiredIf: helpers.withMessage('Dit veld is verplicht', originalLevelChanged)
			},
			options: [
				{
					value: 'LOW',
					label: getRiskLevelText('LOW')
				},
				{
					value: 'MEDIUM',
					label: getRiskLevelText('MEDIUM')
				},
				{
					value: 'HIGH',
					label: getRiskLevelText('HIGH')
				}
			].filter(option => option.value !== originalLevel)
		},
		{
			key: 'fineAndKinneyTool',
			type: 'component',
			label: 'Fine and Kinney Tool',
			validators: {},
			component: FineAndKinneyToolComponent
		},
		{
			key: 'reason',
			type: 'textarea',
			label: levelDeviationLabels.reason,
			validators: {
				required,
				maxLength: maxLength(1000)
			},
			attrs: {
				rows: 6
			}
		}
	];

	return {
		formSchema,
		formFields
	};

};
